import { render, staticRenderFns } from "./ChangeLogDetail.vue?vue&type=template&id=c83be966&scoped=true&"
import script from "./ChangeLogDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogDetail.vue?vue&type=style&index=0&id=c83be966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83be966",
  null
  
)

export default component.exports